/* Avorel — cookie consent behaviour
   Drives Shopify's Customer Privacy API (consent-tracking-api).
   First visit shows the banner; re-prompts every 6 months per device.
   Footer "Cookie settings" link reopens preferences to change or withdraw. */
(function () {
  'use strict';

  var SIX_MONTHS = 183 * 24 * 60 * 60 * 1000; // ms
  var KEY = 'av_cookie_v1';

  function now() { return Date.now(); }
  function readChoice() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function saveChoice(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  // Ensure Shopify's Customer Privacy API is available, then run cb(cp)
  function withCP(cb) {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) { return cb(window.Shopify.customerPrivacy); }
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err && window.Shopify && window.Shopify.customerPrivacy) { cb(window.Shopify.customerPrivacy); }
        });
      }
    } catch (e) {}
  }

  // Write consent through the official API (gates Klaviyo / Meta / analytics)
  function applyConsent(v, cb) {
    withCP(function (cp) {
      try {
        cp.setTrackingConsent({
          analytics: !!v.analytics,
          marketing: !!v.marketing,
          preferences: !!v.preferences,
          sale_of_data: !!v.marketing
        }, function () { if (cb) cb(); });
      } catch (e) { if (cb) cb(); }
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var bar = document.getElementById('av-cookie');
    var modal = document.getElementById('av-ck-modal');
    if (!bar || !modal) return;

    var tgA = document.getElementById('av-ck-analytics');
    var tgM = document.getElementById('av-ck-marketing');
    var tgP = document.getElementById('av-ck-preferences');

    var ALL = { analytics: true, marketing: true, preferences: true };
    var NONE = { analytics: false, marketing: false, preferences: false };

    function showBar() { setTimeout(function () { bar.classList.add('av-show'); }, 60); }
    function hideBar() { bar.classList.remove('av-show'); }

    function escClose(e) { if (e.key === 'Escape') closeModal(); }
    function openModal() { prefill(); modal.classList.add('av-open'); document.addEventListener('keydown', escClose); }
    function closeModal() { modal.classList.remove('av-open'); document.removeEventListener('keydown', escClose); }

    function currentValues() {
      var ch = readChoice();
      return (ch && ch.values) || { analytics: false, marketing: false, preferences: false };
    }
    function prefill() {
      var v = currentValues();
      if (tgA) tgA.checked = !!v.analytics;
      if (tgM) tgM.checked = !!v.marketing;
      if (tgP) tgP.checked = !!v.preferences;
    }
    function finalize(v, kind) {
      applyConsent(v);
      saveChoice({ ts: now(), kind: kind, values: v });
      hideBar();
      closeModal();
    }

    function on(id, fn) { var el = document.getElementById(id); if (el) el.addEventListener('click', fn); }

    on('av-ck-accept', function () { finalize(ALL, 'all'); });
    on('av-ck-decline', function () { finalize(NONE, 'none'); });
    on('av-ck-prefs', openModal);
    on('av-ck-save', function () {
      finalize({
        analytics: !!(tgA && tgA.checked),
        marketing: !!(tgM && tgM.checked),
        preferences: !!(tgP && tgP.checked)
      }, 'custom');
    });
    on('av-ck-declineall', function () { finalize(NONE, 'none'); });
    on('av-ck-acceptall', function () { finalize(ALL, 'all'); });

    var ov = modal.querySelector('[data-ck-close]');
    if (ov) ov.addEventListener('click', closeModal);

    // Public entry point for the footer "Cookie settings" link
    window.avorelOpenCookieSettings = function () { openModal(); };

    injectFooterLink();

    // Decide whether to prompt: first visit, or older than 6 months
    var ch = readChoice();
    var expired = !ch || !ch.ts || (now() - ch.ts > SIX_MONTHS);
    if (expired) {
      showBar();
    } else if (ch && ch.values) {
      applyConsent(ch.values); // re-assert the stored choice each load
    }

    function injectFooterLink() {
      if (document.getElementById('av-ck-settings-link')) return;
      var footer = document.querySelector('footer');
      if (!footer) return;
      var list = footer.querySelector('ul.policy_list') ||
                 (footer.querySelector('a[href*="/policies/"]') || {}).closest &&
                 footer.querySelector('a[href*="/policies/"]').closest('ul');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'av-ck-settings-link';
      btn.textContent = 'Cookie settings';
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.addEventListener('click', function () { window.avorelOpenCookieSettings(); });
      if (list && list.tagName === 'UL') {
        // Match the policy-link styling exactly
        var sample = list.querySelector('a');
        btn.className = sample ? sample.className : 'footer-utilities__text';
        btn.style.cssText = 'background:none;border:0;padding:0;margin:0;font:inherit;color:inherit;cursor:pointer;';
        var li = document.createElement('li');
        li.appendChild(btn);
        list.appendChild(li);
      } else {
        btn.className = 'footer-utilities__text';
        btn.style.cssText = 'background:none;border:0;padding:0;margin-top:10px;font:inherit;color:inherit;cursor:pointer;text-decoration:underline;text-underline-offset:3px;opacity:.85;display:inline-block;';
        footer.appendChild(btn);
      }
    }
  });
})();
